<template>
	<div class="fixOrder">
		<div class="total">
			<meta name="viewport"
				content="width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0,user-scalable=no" />
			<img height="150px" width="100%" src="../../../public/banner.png" />
			<div class="villageName">{{ villageName }}</div>

			<!-- 选择业主的弹出框 -->
			<van-popup v-model="userListShow" round position="bottom" style="height: 50%; padding-top: 4px;">
				<van-checkbox-group>
					<van-cell-group>
						<van-cell v-for="(item, index) in userInfoList" clickable :key="item.id" @click="toggle(item)">
							<div style="line-height: 1.6;">
								<div style="font-size: 18px;">{{ item.realNameS }}</div>
								<div style="color: #999; font-size: 18px;">{{ item.mobileS }}</div>
							</div>
							<template #right-icon>
								<van-checkbox :name="item" ref="checkboxes" />
							</template>
						</van-cell>
					</van-cell-group>
				</van-checkbox-group>
			</van-popup>
			<div class="Order">
				<div class="one">
					<van-image style="width: 1.0625rem;height: 1.0625rem;" src="danwei.png"></van-image>
					<div class="oneTitle">所在房屋</div>
				</div>
				<div class="two">
					<div class="twoTitle">
						<div class="twoBround">
							<el-input type="text" v-model="roomNumber" class="no-border" placeholder="请输入房号" style="">
								<el-button slot="append" icon="el-icon-search" @click="searchRealName"></el-button>
							</el-input>
						</div>
					</div>
				</div>
				<div v-if="userInfoShow">
					<div class="one">
						<van-image style="width: 1.0625rem;height: 1.0625rem;" src="ok.png"></van-image>
						<div class="oneTitle">姓名</div>
					</div>
					<div class="two">
						<div class="twoTitle">
							<div class="twoBround">
								<div class="twoPrice">{{ selectedUser.realNameS }}</div>
							</div>
						</div>
					</div>
					<div class="one">
						<van-image style="width: 1.0625rem;height: 1.0625rem;" src="ok.png"></van-image>
						<div class="oneTitle">手机号</div>
					</div>
					<div class="two">
						<div class="twoTitle">
							<div class="twoBround">
								<div class="twoPrice">{{ selectedUser.mobileS }}</div>
							</div>
						</div>
					</div>
					<div class="one">
						<van-image style="width: 1.0625rem;height: 1.0625rem;" src="price.png"></van-image>
						<div class="oneTitle">缴费金额</div>
					</div>
					<div class="two">
						<div class="twoTitle">
							<div class="twoBround">
								<el-input type="number" v-model="payMoney" class="no-border" placeholder="请输入缴费金额"
									style="font-size: 0.9375rem;">
								</el-input>
							</div>
						</div>
					</div>
				</div>

				<div class="popContainer" v-show="turmAgree">
					<div style="height: 100%;" @click="noAgree(false)"></div>
					<transition>
						<div class="transition-agree">
							<div style="height: 97%;margin-bottom: 3%;overflow-y: auto;">
								<div style="font-size: 0.8125rem;font-weight: bold;margin-top: 0.625rem;">《扫码缴费个人用户缴费协议》
								</div>
								<div class="txtAgree">
									本协议是扫码缴费与您就自助缴费服务的使用等相关事项所订立的有效合同。请您仔细阅读本协议，如果您对本协议的条款有疑问，请通过扫码缴费客服渠道进行询问，扫码缴费将向您解释条款内容。如果您不同意本协议的任何内容，或者无法准确理解扫码缴费对条例的解释，请不要进行后续操作。您通过扫码缴费相关页面点击确认或以其他方式选择接受本协议，即表示您同意接受本协议的全部内容。
								</div>
								<div class="titAgree">一、您的权利与义务</div>
								<div class="textAgree">
									您自愿申请或使用扫码缴费缴费服务。对本服务如有疑问、建议或意见时，可以拨打扫码缴费客服电话：4009920818或登录扫码缴费网站http://scanpayment.yinheyun.com.cn/admin.php进行咨询和投诉。
								</div>
								<div class="textAgree">
									使用本服务时，请您按照具体页面提示提供必要的缴费信息，（如：缴费单位、用户编号等），您理解并同意扫码缴费，根据您提供的缴费信息，向相应的水、电、燃气等缴费单位（以下简称“缴费单位"）
									查询您的户号地址等账单信息，以便您确认并准确缴费。帮助您解决潜在纠纷，您理解并同意扫码缴费可将您的用户编号提供给相对应的缴费单位。部分缴费单位支持缴费户号自动查询功能，您可以选择授权扫码缴费向该缴费单位提供您的身份信息，用于自动查询您名下关联的缴费户号及户号地址信息，以便您进行确认。
								</div>
								<div class="textAgree">扫码缴费重视您的信息保护，遵循合法、正当、要的原则。依照法律规定，严格保护您的信息。如有任何疑问，请随时联系我们。</div>
								<div class="textAgree">
									您使用本服务时实施的所有行为应当遵守国家法律、法规、部门规章的相关规定以及银行业金融机构的相关业务规则。同时，不得违反社会公序良俗。</div>
								<div class="textAgree">您使用本服务应当通过扫码缴费网站，手机银行客户端，以及扫码缴费的特定方式链接登录</div>
								<div class="textAgree">
									使用本服务过程中提供的资料真实、准确、完整、有效。扫码缴费按照您提供的相关信息为您提供相应的服务，我们善意的提醒您，如您提供不真实、不准确、不完善或已经失效的信息，您需要承担相应的损失或责任。
								</div>
								<div class="textAgree">
									正确填写账单信息，并且妥善保管预留信息，除使用本服务外，不要向任何其他人、其他网站、电话或短信的问询提供预留的信息内容。如您对账单信息内容有疑问的，您可以自行联系相关的缴费单位。您理解并同意，您使用本协议约定服务且通过系统发送的指令均系由您本人作出的真实意思表示，该指令一经发出即无法变更或撤销。不论本协议是否终止，基于您发的指令而产生的款项和费用无法退还。扫码缴费不因您的指令产生的任何损失承担赔偿责任。
								</div>
								<div class="textAgree">
									我们善意的提示您，使用本服务过程中使用的银行卡应当为您本人所有或者己经得到持卡人有效授权，否则您需要承担相关的损失和责任。经您点击确认后，相关支付指令无法变更或撤销。
								</div>
								<div class="textAgree">您理解并同意，您不得以第三方发生纠纷为理由拒绝支付使用本服务的应付款项。</div>
								<div class="titAgree">二、扫码缴费的权利与义务</div>
								<div class="textAgree">
									扫码缴费有权根据您在使用扫码缴费服务过程中授权提供或产生的资信情况或交易记录，决定是否受理您的服务申请，并且可以根据扫码缴费账户认证信息等相关要素对您从事交易的权限和身份进行核实。
								</div>
								<div class="textAgree">
									扫码缴费有权根据自身业务发展，增加、减少或撤销缴费服务项目，调整缴费服务的内容，并且有权对本服务进行升级、改造。我们善意的提示您，因您通过本服务申请缴费的账单逾期或者扫码缴费账户资金不足等任何原因导致账单支付不成功的，扫码缴费将向您反馈失败信息，因此导致您预期时
									间增长或产生其他损失的，您需要承担相应的损失或责任，因扫码缴费故意或重大过失原因导致的除外。即便如此，若扫码缴费向您反馈的信息为缴费成功，但因对应服务银行及/或缴费单位的系统或操作导致该账单并未实时支付，最终导致您需要支付滞纳金的，扫码缴费不应承担责任。若您对滞纳金有异议的，可以直接与对应的缴费单位协商解决，扫码缴费将尽可能提供协。
								</div>
								<div class="textAgree">
									扫码缴费应当在技术上确保整个网络交易平台的安全、有效、正常运行，保证您能够顺利使用本协议服务，并向您提供交易记录、交易资金状态、账户状态等查询的服务。但不承担通讯，停电故障、黑客攻击、相关机构单位出账问题、不可抗力等非扫码缴费原因所引起交易中断，交易错误引起的责任。
								</div>
								<div class="textAgree">扫码缴费承诺不会以任何形式挪用您使用本服务的资金。</div>
								<div class="titAgree">三、差错处理</div>
								<div class="textAgree">
									扫码缴费应当在技术上确保整个网络交易平台的安全、有效、正常运行，保证您能够顺利使用本协议服务，并向您提供交易记录、交易资金状态、账户状态等查询的服务。但不承担通讯，停电故障、黑客攻击、相关机构单位出账问题、不可抗力等非扫码缴费原因所引起交易中断，交易错误引起的责任。
								</div>
								<div class="titAgree">四、协议的中止和终止</div>
								<div class="textAgree">如您在扫码缴费平台上存在违法行为或违反本协议的行为，或因您此前使用本服务的行为引发争议的，扫码缴费仍可行使追究的权利。</div>
								<div class="textAgree">我们善意的提示您，扫码缴费不对下述任意情况而发生的中断或终止而承担任何赔偿责任</div>
								<div class="textAgree">扫码缴费基于客观证据，发现您违反本服务条款的规定，扫码缴费可中断或终止向您提供部分或全部服务功能，并将您的用户资料加以删除。
								</div>
								<div class="textAgree">
									发现您注册资料虛假、异常交易或有疑义或有违法嫌疑时，扫码缴费不经通知，有权先中断或终止您扫码缴费账户、密码，并拒绝你使用部分或全部服务功能。</div>
								<div class="titAgree">五、违约责任</div>
								<div class="textAgree">
									本协议任何一方违反本协议规定的内容，给另一方造成经济损失的，应当承担违约责任。违约方应当赔偿因其违约行为给守约方造成的直接经济损失。</div>
								<div class="titAgree">六、免责条款</div>
								<div class="textAgree">
									我们善意的提示您，若您通过本服务申请缴费的账单为谕期账单，导致缴费的结果为销账失败，您需要承担相应的损失或责任。若您对此存在疑义，可与相应的缴费单位进行协商，扫码缴费将尽可能提供协助。
								</div>
								<div class="titAgree">七、其他</div>
								<div class="textAgree" style="margin-bottom: 0.625rem;">
									为了进一步改善用户体验，扫码缴费将会持续开发新服务，为用户提供版本升级，功能升级等服务和内容更新。这些更新将会持续同步，在本协议条款当中，更新内容经公布后生效。若您不同意变更修改后的条款内容，你有权停止使用相关服务。双方协商一致的，也可另行变更相关服务和对应条款内容。如果更新内容涉及您的主要杈利和责任，我们会向您进行提示。
								</div>
							</div>
						</div>
					</transition>
				</div>

			</div>
			<div class="Wrid">
				<div class="rid">
					<van-checkbox v-model="checked" checked-color="#ee0a24">我已阅读并同意</van-checkbox>
					<div style="color: #00A0E9;" @click="btnAgree()">《缴费协议》</div>
				</div>
			</div>
			<van-button type="primary" @click="configData()" class="payBtn" :loading="payBtnStatus"
				loading-text="支付中...">立即支付</van-button>
			<div
				style="width: 90%;margin-top: 0.785rem;margin-bottom: 1.75rem;margin-left:5%;display: flex;justify-content: center;">
				<van-image src="xiaoma.png" style="width: 2.75rem;height: 0.65rem;"></van-image>
				<div style="color:rgb(117,117,117);font-size: 0.5rem;margin-left: 0.125rem;">技术支持</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'HomeIndex',
	data() {
		return {
			villageName: '',//小区名称 海口市秀英区绿地文化城小区业主委员会
			villageId: '',//小区id 1710853249751474178
			mId: '',//商户号 10093394
			payMoney: '',//付款金额
			roomNumber: '',//房号
			selectedUser: '',//选中的业主信息
			userInfoList: [],//业主列表
			userListShow: false,//业主列表显示
			userInfoShow: false,//缴费信息展示

			timeLeft: 3,
			payBtnStatus: false,//支付按钮状态
			mustOrder: false,
			turmAgree: false,
			checked: true,
			formData: "",
			payType: "",//支付方式
			dealMode: "",//缴费类型
			markMoney: 0.00,
		};
	},
	components: {
	},
	filters: {
	},
	methods: {
		//关闭缴费协议
		noAgree(e) {
			this.turmAgree = e
		},
		//缴费协议
		btnAgree() {
			this.turmAgree = true
		},
		// 搜索业主
		searchRealName() {
			if (this.roomNumber == "") {
				this.$toast("查询信息不能为空,请您输入房号再进行查询");
			} else {
				this.$toast.loading({ message: '加载中...', forbidClick: true, duration: 1, });
				this.$request.selOwner({
					housingId: this.villageId,
					roomNumber: this.roomNumber,
				}).then(res => {
					if (res.code == 0) {
						this.userInfoList = res.result;
						this.userListShow = true;
					} else {
						this.$toast(res.message);
					}
				})
			}
		},
		//选中业主
		toggle(item) {
			console.log(item);
			this.selectedUser = item;
			this.userListShow = false;
			this.userInfoShow = true;


		},
		//定时器
		timer() {
			this.payBtnStatus = true
			this.timer = setInterval(() => {
				if (this.timeLeft > 0) {
					this.timeLeft -= 1;
				} else {
					clearInterval(this.timer);
					// clearInterval(); // 停止倒计时
					this.payBtnStatus = false
				}
			}, 1000);
			this.timeLeft = 3
		},
		//非空验证
		verify() {
			if (!this.checked) {
				this.$toast('请您阅读并勾选《缴费协议》后,继续进行缴费');
				return false
			}
			if (!this.roomNumber || this.roomNumber.trim() === '') {
				this.$toast('请输入房号');
				return false
			}
			if (!this.selectedUser) {
				this.$toast('选择业主信息');
				return false
			}
			if (!this.payMoney || this.payMoney.toString().trim() === '') {
				this.$toast('请输入金额');
				return false
			}
			return true;
		},
		//拉起支付
		goPay(transNo) {
			this.$request.pay({
				transNo: transNo,
				mId: this.mId,
				amt: this.payMoney,
				payType: this.payType,
			}).then(res => {
				if (res.code == 0) {
					let resJ = JSON.parse(res.result)
					console.log(123,resJ.qrcode);
					
					window.location.href = resJ.qrcode;
				} else {
					this.$toast(res.message);
				}
			})
		},
		//提交
		configData(event) {
			if (!this.verify()) {
				return false;
			}
			// this.payBtnStatus = true
			this.$toast.loading({ message: '加载中...', forbidClick: true, duration: 1, });
			this.$request.confirmOrder({
				housingId: this.villageId,
				roomId: this.selectedUser.roomId,
				receivableMoney: this.payMoney,
				realName: this.selectedUser.realName,
				dealMode: this.dealMode,
			}).then(res => {
				if (res.code == 0) {
					this.goPay(res.result);
				} else {
					this.$toast(res.message);
				}
			})

			return false












			// // return
			// this.$request.addMemberPayment({
			// 	store_id: this.$storage.getLocal('store_id'),
			// 	template_id: this.$storage.getLocal('template_id'),
			// 	project_id: this.formData.project_id,
			// 	content: arr,
			// }).then(res => {
			// 	if (res.code == 1) {
			// 		this.$request.wxPayment({
			// 			storeid: this.$storage.getLocal('store_id'),
			// 			order_no: res.data.order_no,
			// 			payType: this.pageType,
			// 		}).then(res => { //已选商品
			// 			if (res.code == 0) {
			// 				this.$toast.loading({
			// 					message: '加载中...',
			// 					forbidClick: true,
			// 					duration: 1,
			// 				});
			// 				window.location.href = res.data.url;
			// 			} else {
			// 				this.$toast.fail(res.msg);
			// 			}
			// 		})

			// 	}
			// })
		},

	},
	created() {
		// let a =
		// 	"{\"returnCode\":\"0000\",\"returnMsg\":\"下单成功\",\"qrcode\":\"https://qr.95516.com/03040000/ODg4OFE9ODAxMDg1NjIyNjA4MTIxNjE3\"}"
		// console.log(1,a);
		// let b = JSON.parse(a)
		// console.log(2,b);
		
		// return false
		this.$storage.setLocal(this.$route.query.villageName, 'villageName');
		this.$storage.setLocal(this.$route.query.villageId, 'villageId');
		this.$storage.setLocal(this.$route.query.mId, 'mId');
		this.villageName = this.$route.query.villageName
		this.villageId = this.$route.query.villageId
		this.mId = this.$route.query.mId
		let client = this.$model.model();
		if (client == '微信端') {
			this.dealMode = '6';
			this.payType = '1';
		} else if (client == '支付宝端') {
			this.dealMode = '9';
			this.payType = '2';
		} else {
			this.dealMode = '6';
			this.payType = '1';
		}
	}
}
</script>

<style scoped>
::v-deep .no-border .el-input__inner {
	border: none !important;
	box-shadow: none !important;
	padding: 0;
	color: #000;
	font-size: 0.9375rem;
}

::v-deep .no-border .el-input__inner:focus {
	outline: none;
	border-color: transparent;
}


::v-deep .el-select .el-input__inner::placeholder {
	color: #777777;
	font-size: 0.9375rem;
}

::v-deep .el-input__inner::placeholder {
	color: #777777;
	font-size: 0.9375rem;
}

::v-deep.van-checkbox__icon--disabled .van-icon {
	background-color: #DD0B0D;
	border-color: #DD0B0D;
}

::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
	color: white;
}

::v-deep .van-button--primary {
	border: none;
}

.villageName {
	font-weight: bold;
	font-family: DOUYU;
	width: 190px;
	font-size: 20px;
	color: white;
	position: absolute;
	top: 15px;
	left: 25px;
}

.rid {
	display: flex;
}

.Wrid {
	justify-content: space-between;
	display: flex;
	margin-top: 15%;
	width: 90%;
	margin-left: 5%;
	font-size: 0.75rem;
}

.fixOrder {
	background: #f3f3f3;
	background-size: 100% auto;
	border: 1px solid #f3f3f3;
	height: 100vh;
	overflow-y: auto;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}


.textAgree {
	font-size: 0.625rem;
	text-align: left;
	width: 90%;
	margin-left: 5%;
	text-indent: 1.25rem;
}

.txtAgree {
	font-size: 0.625rem;
	text-align: left;
	width: 90%;
	margin-left: 5%;
	text-indent: 1.25rem;
	margin-top: 0.625rem;
}

.titAgree {
	text-align: left;
	width: 90%;
	margin-left: 5%;
	font-size: 0.75rem;
	font-weight: bold;
}

.Order {
	width: 92%;
	background-color: white;
	margin-left: 4%;
	margin-top: -2.0rem;
	padding-bottom: 1.25rem;
	border-radius: 0.3125rem;
	padding-top: 1.25rem;
	position: relative;
}

.one {
	width: 90%;
	margin-left: 5%;
	display: flex;
}

.two {
	width: 87%;
	margin-left: 8%;
	border-left: 2px solid #dd0b0d;
	display: flex;
	padding-top: 1.25rem;
}


.oneTitle {
	font-size: 0.9375rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	margin-left: 0.375rem;
}


.twoTitle {
	width: 90%;
	margin-left: 0.75rem;
	padding-bottom: 1.25rem;
}

.twoBround {
	border-bottom: 1px solid #DDDDDD;
	display: flex;
	font-size: 0.9375rem;
	font-weight: bold;
	padding-bottom: 0.1875rem;
}

.twoPrice {
	margin-top: -0.1875rem;
}




.payBtn {
	/* top: 50px; */
	margin-top: 1.0rem;
	width: 92%;
	height: 1.4rem;
	background-color: #dd0b0d;
	margin-left: 4%;
	padding-bottom: 0.625rem;
	border-radius: 1.5625rem;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	padding-top: 0.5rem;
	display: block;
	height: 55px;
	font-size: 19px;
}

.popContainer {
	z-index: 3;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.3);
}

.transition-agree {
	width: 80%;
	text-align: center;
	border-radius: 10px;
	position: absolute;
	z-index: 2;
	top: 150px;
	left: 10%;
	height: 60vh;
	box-shadow: 0px 0px 10px #888888;
	background-color: #fff;
	box-sizing: border-box;
	overflow-y: auto;
}

.transition-four {
	width: 80%;
	text-align: center;
	border-radius: 10px;
	z-index: 2;
	top: 100px;
	left: 10%;
	box-shadow: 0px 0px 10px #888888;
	background-color: #fff;
	box-sizing: border-box;
	overflow-y: auto;
}

.transition-box {
	width: 80%;
	text-align: center;
	border-radius: 10px;
	position: absolute;
	z-index: 2;
	top: 150px;
	left: 10%;
	height: 40vh;
	box-shadow: 0px 0px 10px #888888;
	background-color: #fff;
	box-sizing: border-box;
}
</style>
